import * as React from 'react';
import { Modal as SemanticModal, Grid } from 'semantic-ui-react';
import { CloseIcon } from '../Icon';


var Modal = function (_a) {
    var children = _a.children, extraContent = _a.extraContent, trigger = _a.trigger, title = _a.title, subtitle = _a.subtitle, className = _a.className;
    var _b = React.useState(false), isOpen = _b[0], setIsOpen = _b[1];
    var _c = React.useState(), modalRef = _c[0], setModalRef = _c[1];
    var _d = React.useState(false), isModalFullScrolled = _d[0], setIsModalFullScrolled = _d[1];
    var handleIconClick = React.useCallback(function () {
        setIsOpen(false);
    }, []);
    var handleOpen = React.useCallback(function () {
        setIsOpen(true);
    }, []);
    // note: using callback instead of ref as a workaround to get element ref
    // when node is mounted on DOM instead of when components itself mounts
    var handleModalRef = React.useCallback(function (node) {
        setModalRef(node);
    }, []);
    var hasOverflow = modalRef && modalRef.scrollHeight > modalRef.clientHeight;
    var handleScroll = React.useCallback(function (event) {
        var _a = event.target, scrollHeight = _a.scrollHeight, scrollTop = _a.scrollTop, clientHeight = _a.clientHeight;
        var isScrolledToBottom = Math.floor(scrollHeight) - Math.floor(scrollTop) ===
            Math.floor(clientHeight);
        if (!isScrolledToBottom && !isModalFullScrolled) {
            // nothing to do, modal is not full scrolled (prevents unneeded re-renders)
            return;
        }
        setIsModalFullScrolled(isScrolledToBottom);
    }, [isModalFullScrolled]);
    return (React.createElement(SemanticModal, { trigger: trigger, className: "Modal pluggy " + (className || ''), open: isOpen, onOpen: handleOpen, onClose: handleIconClick },
        React.createElement(SemanticModal.Header, null,
            React.createElement(Grid, { columns: 2 },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { textAlign: 'left', className: 'modal-title' }, title),
                    React.createElement(Grid.Column, { textAlign: 'right' },
                        React.createElement(CloseIcon, { onClick: handleIconClick })),
                    React.createElement(Grid.Column, { className: 'value-column', textAlign: 'left' }, subtitle),
                    React.createElement(Grid.Column, null)))),
        React.createElement(SemanticModal.Content, { scrolling: true, onScroll: handleScroll },
            React.createElement("div", { className: 'scroll-container', ref: function (node) { return handleModalRef(node); } },
                React.createElement(SemanticModal.Description, { className: hasOverflow ? 'has-scroll' : '' },
                    React.createElement(Grid, { columns: 2 }, children),
                    extraContent),
                hasOverflow && !isModalFullScrolled && (React.createElement("div", { className: 'scroll-shadow' }))))));
};
export default React.memo(Modal);
